import React, { ReactNode, memo } from 'react';

interface ContainerProps {
    label: string;
    children: ReactNode;
}

const Container: React.FC<ContainerProps> = ({ label, children }) => {
    console.log('-----   this is container render  -----------', label);
    return (
        <div className="container">
            <div className="content">
                <h2>
                    {label}
                </h2>
                {children}
            </div>
        </div>
    );
};

export default memo(Container);